import React from "react";

export default function InsurancePolicyCard({
  strategy = {},
  settings,
  onChange,
  onRecalculate,
  loading = false,
}) {
  const currency = settings?.currency || "EUR";

  const handleChange = (field, value) => {
    if (typeof onChange !== "function") return;

    onChange(field, Number(value));
  };

  return (
    <div className="bg-white rounded-xl border border-slate-200 p-4">
      <h2 className="text-lg font-semibold text-slate-900">
        Candidate Financing Strategy
      </h2>

      <p className="text-sm text-slate-500 mt-1">
        Simulate a proposed insurance-based financing strategy for this scenario.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-4">
        <PolicyInput
          label={`Annual Premium (${currency})`}
          value={strategy.premium ?? 0}
          min="0"
          onChange={(value) =>
            handleChange("premium", value)
          }
        />

        <PolicyInput
          label={`Deductible / Retention (${currency})`}
          value={strategy.deductible ?? 0}
          min="0"
          onChange={(value) =>
            handleChange("deductible", value)
          }
        />

        <PolicyInput
          label={`Policy Limit (${currency})`}
          value={strategy.policy_limit ?? 0}
          min="0"
          onChange={(value) =>
            handleChange("policy_limit", value)
          }
        />

        <PolicyInput
          label="Coinsurance"
          value={strategy.coinsurance ?? 1}
          min="0"
          max="1"
          step="0.1"
          onChange={(value) =>
            handleChange("coinsurance", value)
          }
        />
      </div>

      <button
        type="button"
        onClick={onRecalculate}
        disabled={loading}
        className="mt-4 px-4 py-2 rounded-lg bg-slate-900 text-white text-sm disabled:cursor-not-allowed disabled:opacity-60"
      >
        {loading ? "Updating..." : "Recalculate"}
      </button>
    </div>
  );
}

function PolicyInput({
  label,
  value,
  onChange,
  step = "10000",
  min,
  max,
}) {
  return (
    <label className="block">
      <span className="text-xs font-medium text-slate-500">
        {label}
      </span>

      <input
        type="number"
        value={value}
        step={step}
        min={min}
        max={max}
        onChange={(event) => onChange(event.target.value)}
        className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
      />
    </label>
  );
}